import { useDispatch, useSelector } from 'react-redux';
import { selectUserProfile } from 'app/pages/Layout/slice/selectors';
import { useCommentSlice } from '../CommentState';
import { CommentWithCommentType } from '../types';
import { generateTimestamp } from '../helper';
import { selectSelectedSection, selectCommunicationMode } from '../CommentState/selectors';

export const useSubmitHandlers = () => {
  const loggedInUser = useSelector(selectUserProfile);
  const sectionData = useSelector(selectSelectedSection);
  const communicationMode = useSelector(selectCommunicationMode);
  const dispatch = useDispatch();
  const { actions } = useCommentSlice();

  // Handle new comment submission
  const handleSubmit = (data: any) => {
    const hasMentions = data.commentMentions && (data.commentMentions.length > 0);
    const newComment: CommentWithCommentType = {
      id: Date.now().toString(),
      text: data.comment,
      createdAt: generateTimestamp(),
      commentAuthor: {
        uid: loggedInUser.uid,
        email: loggedInUser.email,
        fullName: `${loggedInUser.firstname} ${loggedInUser.lastname}`
      },
      commentMentions: data.commentMentions,
      section: sectionData?.sectionLabel || sectionData?.item.label,
      sectionCategory: sectionData?.item.label || 'No Section Category',
      commentType: 'MAIN',
      communicationMode: hasMentions ? communicationMode : null,
      isSkeleton: true
    };
    dispatch(actions.submitComment(newComment));
  };

  // Handle reply submissions
  const handleReplySubmit = (params: any) => {
    const hasMentions = params.commentMentions && (params.commentMentions.length > 0);
    const newReply: CommentWithCommentType = {
      id: params.id, // Use the reply ID from params
      text: params.text,
      createdAt: generateTimestamp(),
      commentAuthor: {
        uid: loggedInUser.uid,
        email: loggedInUser.email,
        fullName: `${loggedInUser.firstname} ${loggedInUser.lastname}`
      },
      commentMentions: params.commentMentions,
      commentType: 'REPLY',
      parentCommentId: params.parentCommentId,
      section: sectionData?.sectionLabel || sectionData?.item.label,
      sectionCategory: sectionData?.item.label || 'No Section Category',
      communicationMode: hasMentions ? communicationMode : null
    };
    dispatch(actions.replySubmitComment(newReply));
  };

  return {
    handleSubmit,
    handleReplySubmit
  };
};
